import React, { useEffect, useState } from "react";
import { endOfDay, startOfDay } from "date-fns";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { KeyboardDatePicker } from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  row: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    alignItems: "flex-end",
    marginBottom: theme.spacing(2),
  },
  dateField: {
    minWidth: 220,
  },
}));

interface ErrorAlertsCustomDateRangeProps {
  from: Date;
  to: Date;
  disabled?: boolean;
  onApply: (range: { from: Date; to: Date }) => void;
}

function ErrorAlertsCustomDateRange({
  from,
  to,
  disabled = false,
  onApply,
}: ErrorAlertsCustomDateRangeProps) {
  const classes = useStyles();
  const [draftFrom, setDraftFrom] = useState(from);
  const [draftTo, setDraftTo] = useState(to);

  useEffect(() => {
    setDraftFrom(from);
    setDraftTo(to);
  }, [from, to]);

  const handleApply = () => {
    onApply({ from: draftFrom, to: draftTo });
  };

  return (
    <Box className={classes.row}>
      <KeyboardDatePicker
        className={classes.dateField}
        disableToolbar
        variant="inline"
        inputVariant="outlined"
        margin="dense"
        label="From"
        format="MM/dd/yyyy"
        value={draftFrom}
        disabled={disabled}
        onChange={(date) => date && setDraftFrom(startOfDay(date))}
        maxDate={draftTo}
      />
      <KeyboardDatePicker
        className={classes.dateField}
        disableToolbar
        variant="inline"
        inputVariant="outlined"
        margin="dense"
        label="To"
        format="MM/dd/yyyy"
        value={draftTo}
        disabled={disabled}
        onChange={(date) => date && setDraftTo(endOfDay(date))}
        minDate={draftFrom}
        maxDate={new Date()}
      />
      <Button
        variant="contained"
        color="primary"
        disabled={disabled}
        onClick={handleApply}
      >
        Apply
      </Button>
    </Box>
  );
}

export default ErrorAlertsCustomDateRange;
